// import { useGetActivityLog } from "../hooks";
import { useEffect } from "react";
import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { ClipboardCheck, Timer } from 'lucide-react';
import { CardContent } from "@shared/ui/card";
import { useBillActivityLog } from "@features/bx/singleBillGenaration/hooks";
import { useParams } from "react-router-dom";

interface TimelineTabProps {
  entityId?: string;
  entityType?: any;
}

export function ActivityLogTab({ entityId, entityType }: TimelineTabProps) {
//   const { data: activityLogs } = useGetActivityLog(entityId, entityType);
const params = useParams();
  const billId = params?.id;
const { data: activityLogs} = useBillActivityLog(billId)

  useEffect(() => {
    logEvent("activityLog_tab_viewed");
  }, []);
  return (
    <div>
      <CardContent>
        {activityLogs?.count === 0 ? (
          <div className="text-center p-8">
            <div className="h-10 w-10 text-gray-400 mx-auto mb-2 flex items-center justify-center">
              <Timer />
            </div>
            <h3 className="text-lg font-medium text-gray-600">
              No Timeline Events
            </h3>
            <p className="text-sm text-gray-500">
              No timeline events available for this request
            </p>
          </div>
        ) : (
          <div className="relative">
            {activityLogs?.map((event, index) => (
              <div key={index} className="mb-8 flex gap-4">
                <div className="relative mt-1.5">
                  <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 text-blue-600 ring-8 ring-white">
                    <div className="h-2.5 w-2.5 rounded-full bg-blue-600"></div>
                  </div>
                  {index < activityLogs?.count - 1 && (
                    <div className="absolute top-6 bottom-0 left-1/2 -translate-x-1/2 w-0.5 h-full bg-gray-200"></div>
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:justify-between">
                    <p className="font-medium">{event.title}</p>
                    <p className="text-sm text-muted-foreground">
                      {event.time}
                    </p>
                  </div>
                  {event.user && (
                    <p className="text-sm mt-0.5">By: {event.user.name}</p>
                  )}
                  {event.description && (
                    <p className="text-sm mt-2 text-muted-foreground">
                      {event.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </div>
  );
}
